import request from '@/utils/request'

export function getzk(query) {
	return request({
		url: 'api/report/getzk',
		method: 'get',
		params: query
	})
}

//api/report/getjcbzy
export function getjcbzy(query) {
	return request({
		url: 'api/report/getjcbzy',
		method: 'get',
		params: query
	})
}

//api/report/getsxbzy

export function getsxbzy(query) {
	return request({
		url: 'api/report/getsxbzy',
		method: 'get',
		params: query
	})
}

 
export function getSymbolReport(query){
  return request({
    url:'api/symbol/gettongji',
    method:"get",
    params:query
  });
}

export function getCigenReport(query) {
	return request({
		url: 'api/rootword/getreport',
		method: 'get',
		params: query
	})
}

export function getCourseReport(query){
  return request({
    url:'api/course/getreport',
    method:"get",
    params:query
  })
}

export function getYueduReport(query) {
	return request({
		url: 'api/read/getreport',
		method: 'get',
		params: query
	})
}
export function getyuedustudylist(query) {
	return request({
		url: 'api/read/getstudylist',
		method: 'get',
		params: query
	})
}

export function getYufaReport(query) {
	return request({
		url: 'api/grammar/getreport',
		method: 'get',
		params: query
	})
}
